import { render, staticRenderFns } from "./CustomerInsuranceAddNew.vue?vue&type=template&id=7c8def44&scoped=true&"
import script from "./CustomerInsuranceAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8def44",
  null
  
)

export default component.exports